<table class="super-table" style="width: 100%" [ngClass]="{ aumicoColors: colored }">
    <thead *ngIf="!transpose && hasSegments" class="header1">
        <tr [style.color]="tableHeaderColor" class="row-Segment super-table-row">
            <ng-container *ngFor="let col of superTableColumns">
                <th *ngIf="col.columnId === 't'" class="title text-align-bottom">
                    <div></div>
                </th>
                <ng-container *ngIf="col.columnId !== 't' && startingColumnIdToSegment.has(col.columnId)">
                    <th
                        class="segment text-align-bottom"
                        [attr.colspan]="startingColumnIdToSegment.get(col.columnId).childColumnsIds.length"
                    >
                        <div>
                            {{ startingColumnIdToSegment.get(col.columnId).segmentTitle }}
                        </div>
                    </th>
                </ng-container>
                <ng-container
                    *ngIf="
                        col.columnId !== 't' &&
                        !startingColumnIdToSegment.has(col.columnId) &&
                        !allSegmentsChildColumnIds.includes(col.columnId)
                    "
                >
                    <th
                        [ngClass]="{
                            'st-column-text': col.type === 'TEXT',

                            ratioColumn: col.isRatio
                        }"
                    >
                        <div></div>
                    </th>
                </ng-container>
            </ng-container>
        </tr>
    </thead>
    <thead class="header2">
        <tr [style.color]="tableHeaderColor" class="row-min-height_plus-border-height row-Header">
            <ng-container *ngIf="!transpose">
                <ng-container *ngFor="let col of superTableColumns; let firstCol = first; let lastCol = last">
                    <th *ngIf="col.columnId === 't' && tableNumber" class="title text-align-bottom">
                        {{ tableNumber + ' ' + col.columnTitle }}
                    </th>
                    <th *ngIf="col.columnId === 't' && !tableNumber" class="title text-align-bottom">
                        {{ col.columnTitle != null && col.columnTitle !== 'null' ? col.columnTitle : '' }}
                    </th>

                    <th
                        *ngIf="col.type === 'CY' || col.belongingYear === 'CY'"
                        class="text-align-bottom column-Highlight"
                        [hamFormat]="resolveEffectiveCellStyles(undefined, col.format)"
                        [isFirstOrLast]="firstCol || lastCol"
                        [ngClass]="{
                            ratioColumn: col.isRatio,
                            'st-column-text': col.type === 'TEXT',
                            'st-column-number': col.type !== 'TEXT'
                        }"
                        [style.background-color]="backgroundColor"
                    >
                        {{ col.columnTitle }}
                    </th>
                    <th
                        *ngIf="col.type !== 'CY' && col.belongingYear !== 'CY' && col.columnId !== 't'"
                        [hamFormat]="resolveEffectiveCellStyles(undefined, col.format)"
                        [isFirstOrLast]="firstCol || lastCol"
                        [ngClass]="{
                            'st-column-text': col.type === 'TEXT',
                            'st-column-number': col.type !== 'TEXT',
                            ratioColumn: col.isRatio
                        }"
                        class="text-align-bottom"
                        [class.highlight-col-2]="col.belongingYear === 'PV'"
                    >
                        {{ col.columnTitle }}
                    </th>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="transpose">
                <th class="title st-column-text text-align-bottom">
                    <div *ngIf="tableNumber" class="row-min-height_plus-border-height">
                        {{ tableNumber + '' + tableTitle }}
                    </div>
                    <div *ngIf="!tableNumber" class="row-min-height_plus-border-height">{{ tableTitle }}</div>
                </th>
                <ng-container
                    *ngFor="let col of transposedColumns; let i = index; let firstCol = first; let lastCol = last"
                >
                    <th
                        *ngIf="col.type !== TransposedSuperTableColumnType.EMPTY"
                        class="text-align-bottom"
                        [hamFormat]="resolveEffectiveCellStyles(undefined, col.format)"
                        [isFirstOrLast]="firstCol || lastCol"
                        [ngClass]="{
                            'st-column-text': col.type === 'TEXT',
                            'st-column-number': col.type !== 'TEXT',
                            ratioColumn: col.isRatio,
                            todoHighlight:
                                highlightTodos &&
                                (superTableRows[i].t === '' ||
                                    superTableRows[i].t == null ||
                                    superTableRows[i].t === '-')
                        }"
                    >
                        <div class="row-min-height_plus-border-height">
                            {{ superTableRows[i].t }}
                        </div>
                    </th>
                    <th
                        *ngIf="col.type === TransposedSuperTableColumnType.EMPTY"
                        class="st-column-number text-align-bottom empty-column"
                    ></th>
                </ng-container>
            </ng-container>
        </tr>
    </thead>
    <ng-container *ngIf="!transpose">
        <ng-container *ngFor="let row of superTableRows; let i = index">
            <ng-container *ngIf="row.rowType === 'TitleRow'">
                <tr
                    [style.color]="tableHeaderColor"
                    class="row-min-height_plus-border-height gray-border-down row-Title row-Header"
                >
                    <ng-container *ngFor="let col of superTableColumns; let firstCol = first; let lastCol = last">
                        <td
                            *ngIf="col.columnId === 't'"
                            class="title text-align-top"
                            [hamFormat]="resolveEffectiveCellStyles(row.format, col.format)"
                            [isFirstOrLast]="firstCol || lastCol"
                            [ngClass]="{
                                todoHighlight: highlightTodos && (row.t === '' || row.t == null || row.t === '-')
                            }"
                        >
                            {{ row.t }}
                        </td>
                        <td
                            *ngIf="col.type === 'CY' || col.belongingYear === 'CY'"
                            class="column-Highlight"
                            [style.background-color]="backgroundColor"
                        >
                            {{ row[col.columnId] }}
                        </td>
                        <td
                            *ngIf="col.type === 'PV' || col.belongingYear === 'PV' || col.belongingYear === 'NY'"
                            [class.highlight-col-2]="col.belongingYear === 'PV'"
                        >
                            {{ row[col.columnId] }}
                        </td>
                    </ng-container>
                </tr>
            </ng-container>
            <ng-container *ngIf="row.rowType === 'EmptyRow'">
                <tr class="space-height gray-border-down row-Empty">
                    <ng-container *ngFor="let col of superTableColumns">
                        <td *ngIf="col.columnId === 't'" class="title text-align-top"></td>
                        <td
                            *ngIf="col.type === 'CY' || col.belongingYear === 'CY'"
                            class="column-Highlight"
                            [style.background-color]="backgroundColor"
                        ></td>
                        <td
                            *ngIf="col.type === 'PV' || col.belongingYear === 'PV' || col.belongingYear === 'NY'"
                            [class.highlight-col-2]="col.belongingYear === 'PV'"
                        ></td>
                    </ng-container>
                </tr>
            </ng-container>
            <ng-container *ngIf="row.rowType === 'Row'">
                <tr
                    [style.color]="textColor"
                    class="row-min-height_plus-border-height gray-border-down super-table-row"
                    [ngClass]="{
                        'black-border-down':
                            superTableRows[i + 1] != null && superTableRows[i + 1].rowType === 'CalcRow',
                        'no-border-down': superTableRows[i + 1] != null && superTableRows[i + 1].rowType === 'TitleRow'
                    }"
                >
                    <ng-container *ngFor="let col of superTableColumns; let firstCol = first; let lastCol = last">
                        <td
                            *ngIf="col.columnId === 't'"
                            class="title text-align-top"
                            [hamFormat]="resolveEffectiveCellStyles(row.format, col.format)"
                            [isFirstOrLast]="firstCol || lastCol"
                            [ngClass]="{
                                todoHighlight: highlightTodos && (row.t === '' || row.t == null || row.t === '-')
                            }"
                        >
                            {{ row.t }}
                        </td>
                        <td
                            *ngIf="col.type === 'CY' || col.belongingYear === 'CY'"
                            class="text-align-top column-Highlight"
                            [hamFormat]="resolveEffectiveCellStyles(row.format, col.format)"
                            [isFirstOrLast]="firstCol || lastCol"
                            [ngClass]="{
                                'st-column-text': col.type === 'TEXT',
                                'st-column-number': col.type !== 'TEXT',
                                ratioColumn: col.isRatio,
                                todoHighlight:
                                    highlightTodos &&
                                    (row[col.columnId] === '' ||
                                        row[col.columnId] === '0.00' ||
                                        row[col.columnId] === '-' ||
                                        row[col.columnId] == null)
                            }"
                            [style.background-color]="backgroundColor"
                        >
                            {{ row[col.columnId] }}
                        </td>

                        <td
                            *ngIf="
                                (col.type === 'PV' || col.belongingYear === 'PV' || col.belongingYear === 'NY') &&
                                col.columnId !== 't'
                            "
                            [hamFormat]="resolveEffectiveCellStyles(row.format, col.format)"
                            [isFirstOrLast]="firstCol || lastCol"
                            [ngClass]="{
                                'st-column-text': col.type === 'TEXT',
                                'st-column-number': col.type !== 'TEXT',
                                ratioColumn: col.isRatio,
                                todoHighlight:
                                    highlightTodos &&
                                    (row[col.columnId] === '' ||
                                        row[col.columnId] === '0.00' ||
                                        row[col.columnId] == null ||
                                        row[col.columnId] === '-')
                            }"
                            class="text-align-top"
                            [class.highlight-col-2]="col.belongingYear === 'PV'"
                        >
                            {{ row[col.columnId] }}
                        </td>
                    </ng-container>
                </tr>
            </ng-container>
            <ng-container *ngIf="row.rowType === 'CalcRow'">
                <tr
                    [style.color]="tableFooterColor"
                    class="row-min-height_plus-border-height row-Total super-table-row"
                >
                    <ng-container *ngFor="let col of superTableColumns; let firstCol = first; let lastCol = last">
                        <td
                            *ngIf="col.columnId === 't'"
                            [hamFormat]="resolveEffectiveCellStyles(row.format, col.format)"
                            [isFirstOrLast]="firstCol || lastCol"
                            class="title text-align-top column-Total"
                            [ngClass]="{
                                todoHighlight: highlightTodos && (row.t === '' || row.t == null || row.t === '-')
                            }"
                        >
                            {{ row.t }}
                        </td>
                        <td
                            *ngIf="col.type === 'CY' || col.belongingYear === 'CY'"
                            [hamFormat]="resolveEffectiveCellStyles(row.format, col.format)"
                            [isFirstOrLast]="firstCol || lastCol"
                            class="text-align-top column-Total column-Highlight st-column-number"
                            [ngClass]="{
                                ratioColumn: col.isRatio,
                                todoHighlight:
                                    highlightTodos &&
                                    (row[col.columnId] === '' ||
                                        row[col.columnId] === '0.00' ||
                                        row[col.columnId] == null ||
                                        row[col.columnId] === '-') &&
                                    col.type !== 'TEXT'
                            }"
                            [style.background-color]="backgroundColor"
                        >
                            {{ row[col.columnId] }}
                        </td>

                        <td
                            *ngIf="
                                (col.type === 'PV' || col.belongingYear === 'PV' || col.belongingYear === 'NY') &&
                                col.columningId !== 't'
                            "
                            [hamFormat]="resolveEffectiveCellStyles(row.format, col.format)"
                            [isFirstOrLast]="firstCol || lastCol"
                            [ngClass]="{
                                title: col.type === 'TEXT',
                                'st-column-number': col.type !== 'TEXT',
                                ratioColumn: col.isRatio,
                                todoHighlight:
                                    highlightTodos &&
                                    (row[col.columnId] === '' ||
                                        row[col.columnId] === '0.00' ||
                                        row[col.columnId] == null ||
                                        row[col.columnId] === '-') &&
                                    col.type !== 'TEXT'
                            }"
                            class="text-align-top column-Total"
                            [class.highlight-col-2]="col.belongingYear === 'PV'"
                        >
                            {{ row[col.columnId] }}
                        </td>
                    </ng-container>
                </tr>
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="transpose">
        <ng-container *ngFor="let row of transposedRows; let j = index">
            <ng-container>
                <tr
                    [style.color]="tableFooterColor"
                    class="row-min-height_plus-border-height gray-border-down super-table-row"
                    [ngClass]="{
                        'row-Total': row.rowType === 'CalcRow',
                        'black-border-down':
                            transposedRows[j + 1] != null && transposedRows[j + 1].rowType === 'CalcRow'
                    }"
                >
                    <td
                        class="title st-column-text"
                        [ngClass]="{
                            todoHighlight: highlightTodos && (row.t === '' || row.t == null || row.t === '-')
                        }"
                    >
                        {{ row.t }}
                    </td>
                    <ng-container
                        *ngFor="let col of transposedColumns; let i = index; let firstCol = first; let lastCol = last"
                    >
                        <td
                            *ngIf="col.type !== TransposedSuperTableColumnType.EMPTY"
                            [hamFormat]="resolveEffectiveCellStyles(undefined, col.format)"
                            [isFirstOrLast]="firstCol || lastCol"
                            class="text-align-bottom st-column-number"
                            [ngClass]="{
                                todoHighlight:
                                    highlightTodos &&
                                    (row['row' + i] === '' ||
                                        row['row' + i] === '0.00' ||
                                        row['row' + i] == null ||
                                        row['row' + i] === '-')
                            }"
                        >
                            {{ row['row' + i] }}
                        </td>
                        <td
                            *ngIf="col.type === TransposedSuperTableColumnType.EMPTY"
                            class="text-align-bottom st-column-number empty-column"
                        ></td>
                    </ng-container>
                </tr>
            </ng-container>
        </ng-container>
    </ng-container>
</table>
